<template>
  <div>
    <div v-if="students && grade">
      <b-table-simple
        :class="$store.state.login.isPaid ? '' : 'plan-table'"
        hover
        small
        caption-top
        bordered
      >
        <b-tbody>
          <b-tr>
            <b-th>Nombre</b-th>
            <b-th v-if="!download">Nivel de Aplicación</b-th>
            <b-th class="text-truncate" style="max-width: 20vw"
              >Matemáticas</b-th
            >
            <b-th class="text-truncate" style="max-width: 20vw">Lenguaje</b-th>
            <b-th>Descargar informe</b-th>
            <b-th v-if="!download">Descargar plantillas</b-th>
          </b-tr>
          <b-tr
            v-for="(student, sIndex) in students[grade.id]"
            :key="sIndex + '-s'"
          >
            <b-td>
              <p class="d-inline-block">
                {{ student.student_name }}
              </p>
              <v-icon 
                v-if="download"
                name="pen" 
                class="d-inline-block ml-2" 
                style="cursor: pointer"
                @click="openEdit(student)" 
              />
            </b-td>
            <b-td v-if="!download">
              <b-select
                v-model="student.last_eureka_level"
                style="max-width: 150px"
              >
                <b-select-option
                  v-for="(level, lIndex) in levels"
                  :key="lIndex + '-l'"
                  :value="level[0]"
                  :style="
                    student.tests.filter(
                      (test) => test.reviewed && test.test_level === level[0]
                    ).length
                      ? 'background-color: #90EE90'
                      : student.tests.filter(
                          (test) => test.started && test.test_level === level[0]
                        ).length
                      ? 'background-color: #DAA520'
                      : 'background-color: white'
                  "
                >
                  <div>
                    {{ level[1] }}
                  </div>
                </b-select-option>
              </b-select>
            </b-td>
            <b-td class="align-middle">
              <eureka-table-button
                :year="year"
                :partialTest="
                  getTest(student.tests, 7, student.last_eureka_level, student)
                "
                @response-admin="
                  (args) => {
                    $emit('review', args);
                  }
                "
                @reload="$emit('get-students', grade.id)"
                :download="download"
              />
            </b-td>
            <b-td class="align-middle">
              <eureka-table-button
                :year="year"
                :partialTest="
                  getTest(student.tests, 6, student.last_eureka_level, student)
                "
                @response-admin="
                  (args) => {
                    $emit('review', args);
                  }
                "
                @reload="$emit('get-students', grade.id)"
                :download="download"
              />
            </b-td>
            <b-td style="min-width: 100px" class="align-middle">
              <div class="text-center">
                <div v-if="!download">
                  <b-button
                    pill
                    variant="primary"
                    size="sm"
                    @click="
                      $emit(
                        'generate-report',
                        student.id,
                        student.last_eureka_level
                      )
                    "
                    v-if="
                      student.tests.filter(
                        (test) =>
                          test.reviewed &&
                          test.test_level === student.last_eureka_level
                      ).length
                    "
                  >
                    Generar Informe
                  </b-button>
                  <div
                    v-else
                    class="text-center"
                    style="max-width: 200px; margin: auto"
                  >
                    Debes revisar y cerrar al menos una evaluación del nivel
                    seleccionado para poder descargar el informe seleccionado.
                  </div>
                </div>
                <b-row v-else>
                  <b-col class="" md="3" cols="12">
                    <b-img
                      @click="
                        $emit(
                          'download-selected',
                          student.download_status,
                          student.id,
                          student.last_eureka_level
                        )
                      "
                      v-if="
                        student.download_status === 0 ||
                        student.tests.filter(
                          (test) =>
                            test.reviewed &&
                            test.test_level === student.last_eureka_level
                        ).length === 2 || student.download_status === 3 || student.download_status === 0
                      "
                      class=""
                      width="31em"
                      :src="downloadIcon"
                      style="cursor: pointer"
                    />
                    <b-img
                      v-else
                      width="31em"
                      :src="downloadIconDisabled"
                      style="cursor: pointer"
                      class=""
                      v-b-tooltip.hover
                      title="Debes revisar ambas pruebas para poder descargar
                            el informe!"
                    />
                  </b-col>
                  <b-col md="9" cols="0">
                    <b-select
                      v-model="student.download_status"
                      class="d-none d-md-block"
                    >
                      <b-select-option :value="1"> Informe </b-select-option>
                      <b-select-option :value="3"> PDF </b-select-option>
                      <b-select-option :value="2"> Protocolo </b-select-option>
                      <b-select-option :value="0"> Borrador </b-select-option>
                    </b-select>
                  </b-col>
                </b-row>
              </div>
            </b-td>
            <b-td v-if="$store.state.login.isPaid">
              <div class="text-center my-2">
                <b-button
                  pill
                  variant="primary"
                  size="sm"
                  @click="
                    $emit(
                      'download-writing-template',
                      student.last_eureka_level
                    )
                  "
                >
                  Descargar Plantilla
                </b-button>
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <div v-if="singleStudent && Object.keys(singleStudent).length > 0">
      <b-table-simple class="plan-table" hover small caption-top bordered>
        <b-tbody>
          <b-tr>
            <b-th>Nombre Estudiante</b-th>
            <b-th>Nivel de Aplicación</b-th>
            <b-th>Matemáticas</b-th>
            <b-th>Lenguaje</b-th>
          </b-tr>
          <b-tr>
            <b-td>{{ singleStudent.student_name }}</b-td>
            <b-td>
              <b-select v-model="singleStudent.last_eureka_level" disabled>
                <b-select-option
                  v-for="(level, lIndex) in levels"
                  :key="lIndex + '-l'"
                  :value="level[0]"
                  :style="
                    singleStudent.tests.filter(
                      (test) => test.reviewed && test.test_level === level[0]
                    ).length
                      ? 'background-color: #90EE90'
                      : singleStudent.tests.filter(
                          (test) => test.started && test.test_level === level[0]
                        ).length
                      ? 'background-color: #DAA520'
                      : 'background-color: white'
                  "
                >
                  <div>
                    {{ level[1] }}
                  </div>
                </b-select-option>
              </b-select>
            </b-td>
            <b-td>
              <b-btn
                variant="primary"
                pill
                @click="
                  goToTest(
                    getTest(
                      singleStudent.tests,
                      7,
                      singleStudent.last_eureka_level,
                      singleStudent
                    )
                  )
                "
              >
                Ir a la Prueba
              </b-btn>
            </b-td>
            <b-td>
              <b-btn
                variant="primary"
                pill
                @click="
                  goToTest(
                    getTest(
                      singleStudent.tests,
                      6,
                      singleStudent.last_eureka_level,
                      singleStudent
                    )
                  )
                "
              >
                Ir a la Prueba
              </b-btn>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>
<script>
import EurekaTableButton from "./EurekaTableButton";
import customTestService from "@/services/customTestService";

export default {
  components: {
    EurekaTableButton,
  },
  props: {
    students: {
      type: Object,
      required: false,
    },
    grade: {
      type: Object,
      required: false,
    },
    levels: {
      type: Array,
      required: true,
    },
    download: {
      type: Boolean,
      default: false,
    },
    year: {
      type: Number,
      required: false,
    },
    singleStudent: {
      type: Object,
      default: () => ({}),
    },
    tests: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      downloadIcon: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_descargar.svg"),
      downloadIconDisabled: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_descargar_dis.svg"),
      copyIcon: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg"),
      continueIcon: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_terminar prueba.svg"),
      reviewIcon: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg"),
      readyIcon: require("../../../assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_listo.svg"),
    };
  },
  methods: {
    openEdit(student) {
      this.$emit('open-edit', student);
    },
    getTest(tests, subject, level, student) {
      try {
        if (
          tests.length &&
          tests.filter(
            (test) => test.test_subject === subject && test.test_level === level
          ).length
        ) {
          return tests.filter(
            (test) => test.test_subject === subject && test.test_level === level
          )[0];
        } else {
          var test = this.tests.filter(
            (test) => test.subject === subject && test.level === level
          )[0];
          var d = {
            student_rut: student.student_rut,
            student_name: student.student_name,
            student_email: student.student_email,
            student_grade: student.id,
          };
          if (test) {
            d["test_id"] = test.id;
          }
          return d;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goToTest(test) {
      if (test.started || test.id) {
        let testURL = `${process.env["VUE_APP_BASE_URL"]}/tests#/t/${test.id}`;
        window.open(testURL, "_blank").focus();
      } else {
        this.generateLink(test);
      }
    },
    generateLink(test) {
      customTestService
        .generateLink({
          test: test.test_id,
          rut: test.student_rut,
          email: test.student_email,
          name: test.student_name,
          videocall_kind: 3,
          student_grade: test.student_grade,
        })
        .then(
          (data) => {
            test.started = true;
            let testURL = `${process.env["VUE_APP_BASE_URL"]}/tests#/t/${data.id}`;
            window.open(testURL, "_blank").focus();
          },
          () => this.$toasted.error("Ocurrió un error. Intenta nuevamente.")
        );
    },
  },
};
</script>
<style scoped></style>
